import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useNavigate } from 'react-router-dom';
import SellTicketsHeader from './SellTicketsHeader';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';
import TicketProvider from './TicketProvider';
import OtherProvider from './OtherProvider';
import OtherProviderModal from './modals/OtherProviderModal';
import LoginModal from './modals/LoginModal';
import { openModal } from '../../core/actions/modal';
// eslint-disable-next-line import/no-unresolved
import IABILET_LOGO from '../../core/assets/img/iabilet-blue.svg';
import { LOGIN_MODAL_NAME, OTHER_PROVIDER_MODAL_NAME } from '../constants/modal';
import { SELL_STEP_1 } from '../constants/steps';

const SellTicketsIntro = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const goToNextStep = () => navigate(`/sell/${SELL_STEP_1}`);
    const onLogoClick = () => {
        dispatch(openModal(LOGIN_MODAL_NAME));
    };
    const onOtherProviderClick = () => {
        dispatch(openModal(OTHER_PROVIDER_MODAL_NAME));
    };

    return (
        <div>
            <Container>
                <Row>
                    <Col lg={{ span: 10, offset: 1 }} md={12}>
                        <SellTicketsHeader title={<FormattedMessage id='sell_intro_header_title'/>} subtitle={<FormattedMessage id="sell_intro_header_subtitle"/>}/>
                        <Row>
                            <TicketProvider logo={IABILET_LOGO} onClick={onLogoClick} />
                            <OtherProvider onClick={onOtherProviderClick} />
                        </Row>
                    </Col>
                </Row>
            </Container>
            <FrequentlyAskedQuestions/>
            <LoginModal goToNextStep={goToNextStep}/>
            <OtherProviderModal />
        </div>
    );
};

export default SellTicketsIntro;
